module.exports = __webpack_public_path__ + "static/webpack-cfdcf3bcc1d6d41f5adae7e252aa1fec.png";